<div class="test-all-wrap">
  <div class="test-brain-wrap">
    <div class="box-checkup-date">{{brainInfoObj.date}}</div>
    <!-- 그리드 레이아웃 시작 -->
    <div class="grid-wrapper">
      <div class="background"><img class="img" src="assets/images/inspection_bg.png"></div>
      <div class="text-left">
        <div class="test-brain-per-box">
          <div>{{brainInfoObj.leftValue + "%"}}</div>
          <span>측정 결과</span>
        </div>
      </div>
      <div class="text-right">
        <div class="test-brain-per-box">
          <div class="brain-right-text-color">
            {{brainInfoObj.rightValue + "%"}}
          </div>
          <span>측정 결과</span>
        </div>
      </div>
      <div class="circle-back">
        <img src="assets/images/bbreport_brain_bg.png" class="test-brain-bg">
      </div>
      <div class="whole-brain">
        <img src="assets/images/bbreport_brain.png" class="test-brain">
      </div>
      <div class="brain-left">
        <img src="assets/images/bbreport_brain_fill_02.png"
        class="test-brain-left"
        [graph-percent]="brainInfoObj.leftValue">
      </div>
      <div class="brain-right">
        <img src="assets/images/bbreport_brain_fill_01.png"
          class="test-brain-right"
          [graph-percent]="brainInfoObj.rightValue">
      </div>
      <div class="brain-txt">
        <span class="desc desc-left">좌뇌</span>
        <span class="desc desc-right">우뇌</span>
      </div>
      <div class="test-brain-text-box">
        <span class="brain-text">{{brainInfoObj.explanation}}</span>
      </div>
      <div class="bottom-box"></div>
    </div>
  </div>
  <div class="test-brain-info-wrap">
    <div class="test-result">
      <div class="test-result-title">검사 세부 결과</div>
      {{brainResultObj.result}}
    </div>
    <div class="test-brain-decline">
      <div class="test-result-title">좌/우뇌 기능 저하 시 보일 수 있는 모습</div>
      <div *ngIf="brainInfoObj.leftValue < 80">
        <div class="left">좌뇌</div>
        {{brainResultObj.left}}
      </div>
      <div *ngIf="brainInfoObj.rightValue < 80">
        <div class="right">우뇌</div>
        {{brainResultObj.right}}
      </div>
    </div>
  </div>
  <!-- 그리드 레이아웃 종료 -->
  <div class="test-exe-info-wrap">
    <div class="test-exe-info-title">
      운동 기능 발달 정도
    </div>
    <div class="test-exe-info-desc">
      <div>
        <div class="instability">0 - 39%</div>
        <span>불안정</span>
      </div>
      <div>
        <div class="guard">40 - 79%</div>
        <span>경계</span>
      </div>
      <div>
        <div class="stability">80% 이상</div>
        <span>안정</span>
      </div>
    </div>
    <test-chart-part [partData]="brainGraphObj.eye"></test-chart-part>
    <test-chart-part [partData]="brainGraphObj.sense"></test-chart-part>
    <test-chart-part [partData]="brainGraphObj.muscle"></test-chart-part>
    <test-chart-part [partData]="brainGraphObj.cross"></test-chart-part>
    <test-chart-part [partData]="brainGraphObj.space"></test-chart-part>
    <test-chart-part [partData]="brainGraphObj.exe_cel"></test-chart-part>
    <test-chart-part [partData]="brainGraphObj.plan"></test-chart-part>
  </div>
</div>
